import React from 'react'
import AdminFooter from '../sections/AdminFooter'
import AdminHeader from '../sections/AdminHeader'
import ToolbarNav from './ToolbarNav'


function AppLayout({children}) {
    return (
        <>
        <div className="main" >
            <AdminHeader />
                {children}
            <AdminFooter />
        </div>
        <ToolbarNav/>
        </>
    )
}

export default AppLayout